import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const BlockedUserModal = ({isModalOpen, setModalOpen, banMessage})=> {

  const toggleModal = ()=> setModalOpen(!isModalOpen);

  return (
    <Modal isOpen={isModalOpen} toggle={toggleModal} centered>

      <ModalHeader toggle={toggleModal} cssModule={{'modal-title': 'w-100 text-center'}}>
         Account suspended!
      </ModalHeader>

      <ModalBody>
        <p className="f-16 text-center">
          { banMessage && banMessage.length !== 0
            ? <><strong>Reason: </strong> {banMessage} </>
            : <>Your account was limited, please contact our support at <a href="mailto: hi@earndorado.com">hi@earndorado.com</a> for more details!</>
          }
        </p>
      </ModalBody>

    </Modal>
  )
}

export default BlockedUserModal
